import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Blog — Cognitive Performance for Gamers | NeuroRank';
    return () => { document.title = 'NeuroRank | Cognitive Combine'; };
  }, []);

  useEffect(() => {
    fetch('/api/blog')
      .then(r => r.json())
      .then(d => setPosts(d.posts || []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container" style={{ paddingTop: 48, paddingBottom: 80 }}>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        style={{ marginBottom: 40 }}
      >
        <p style={{ fontSize: 11, letterSpacing: 3, textTransform: 'uppercase', color: 'var(--accent)', fontWeight: 700, marginBottom: 8 }}>
          NEURORANK BLOG
        </p>
        <h1 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 900, marginBottom: 8 }}>
          Cognitive Performance
        </h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: 15, maxWidth: 560 }}>
          The science behind reaction time, aim, decision-making, and what actually separates good players from great ones.
        </p>
      </motion.div>

      {loading && (
        <div style={{ color: 'var(--text-muted)', fontSize: 14 }}>Loading posts...</div>
      )}

      {!loading && posts.length === 0 && (
        <div className="card" style={{ textAlign: 'center', padding: '48px 24px' }}>
          <p style={{ color: 'var(--text-muted)', marginBottom: 8 }}>No posts yet.</p>
          <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>
            Run <code style={{ background: 'var(--bg-elevated)', padding: '2px 6px', borderRadius: 4 }}>npm run blog</code> in marketing-automation/ to generate the first post.
          </p>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20 }}>
        {posts.map((post, i) => (
          <motion.div
            key={post.slug}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: i * 0.05 }}
          >
            <Link
              to={`/blog/${post.slug}`}
              style={{ textDecoration: 'none', display: 'block', height: '100%' }}
            >
              <div
                className="card"
                style={{ height: '100%', cursor: 'pointer', transition: 'border-color 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent)'}
                onMouseLeave={e => e.currentTarget.style.borderColor = ''}
              >
                {post.date && (
                  <p style={{ fontSize: 11, color: 'var(--text-muted)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8, fontFamily: 'var(--font-mono)' }}>
                    {post.date}
                  </p>
                )}
                <h2 style={{ fontSize: 17, fontWeight: 800, lineHeight: 1.35, marginBottom: 10, color: 'var(--text-primary)' }}>
                  {post.title}
                </h2>
                {post.description && (
                  <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 16 }}>
                    {post.description}
                  </p>
                )}
                <span style={{ fontSize: 13, color: 'var(--accent)', fontWeight: 600 }}>
                  Read more →
                </span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
